import { isEmpty } from 'lodash-es';
import { useFela } from 'react-fela';
import { FormattedMessage } from 'react-intl';

import { MemberEntityType } from '@/modules/api/codegen';
import { Button, Empty, Icon, Loadable, Text } from '@/modules/ui';

import { useFetchGroupMembers } from '../../hooks';
import type { Group, GroupMember } from '../../types';
import { chevronRightIcon, container, groupButton } from './GroupMembers.rules';

export interface GroupMembersProps {
    id: Group['id'];
    openNestedGroup: (groupMember: GroupMember) => void;
}

export const GroupMembers = ({ id, openNestedGroup }: GroupMembersProps) => {
    const { showLoader, groupMembers } = useFetchGroupMembers(id);

    const { css } = useFela();

    return (
        <Loadable showLoader={showLoader}>
            <ul className={css(container)}>
                {isEmpty(groupMembers) && <Empty size='small' text={<FormattedMessage id='group.members.list.empty' />} />}
                {groupMembers.map(member => (
                    <li key={member.email}>
                        {member.type === MemberEntityType.GROUP ? (
                            <Button type='text' onClick={() => openNestedGroup(member)} customStyle={groupButton}>
                                {member.email}
                                <Icon type='dropdown' customStyle={chevronRightIcon} />
                            </Button>
                        ) : (
                            <Text variant='ParagraphSmallMedium' color='foregroundsTertiary'>
                                {member.email}
                            </Text>
                        )}
                    </li>
                ))}
            </ul>
        </Loadable>
    );
};
